import styled from 'styled-components'

export const BaseCurrencyLabelRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
